import { Box, Container, Grid, Typography, Button, Card } from "@mui/material";
import CodeIcon from "@mui/icons-material/Code";
import StorageIcon from "@mui/icons-material/Storage";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import SecurityIcon from "@mui/icons-material/Security";
import InsightsIcon from "@mui/icons-material/Insights";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import { motion } from "framer-motion";
import capabilitiesImage from "../../assets/home/capabilities.png";
import DeveloperModeIcon from "@mui/icons-material/DeveloperMode";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useNavigate } from "react-router-dom";
const slideLeft = {
  hidden: { opacity: 0, x: -80 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

const slideRight = {
  hidden: { opacity: 0, x: 80 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

// const capabilities = [
//   {
//     icon: <CodeIcon />,
//     title: "SAP Development",
//     desc: "Custom SAP enhancements, ABAP development, workflows, forms, reports, and business-specific technical solutions.",
//   },
//   {
//     icon: <StorageIcon />,
//     title: "SAP Data Migration",
//     desc: "Clean, transform, validate, and migrate enterprise data securely across SAP environments.",
//   },
//   {
//     icon: <CloudDoneIcon />,
//     title: "SAP Cloud Solutions",
//     desc: "Modern SAP cloud adoption, integration, deployment, and optimization for scalable operations.",
//   },
//   {
//     icon: <SecurityIcon />,
//     title: "SAP Security",
//     desc: "Role design, authorization control, access governance, and secure SAP system administration.",
//   },
//   {
//     icon: <InsightsIcon />,
//     title: "Process Optimization",
//     desc: "Improve business workflows, automate repetitive tasks, and streamline operational performance.",
//   },
//   {
//     icon: <IntegrationInstructionsIcon />,
//     title: "System Integration",
//     desc: "Connect SAP with web apps, APIs, third-party platforms, and enterprise systems.",
//   },
// ];
const capabilities = [
  {
    icon: <BusinessCenterIcon />,
    title: "SAP Consulting & Implementation",
    path: "/services/sap-consulting-implementation",
    desc: "Accelerate digital transformation with end-to-end SAP consulting, implementation, and enterprise solution deployment.",
  },
  {
    icon: <SupportAgentIcon />,
    title: "SAP Support & Managed Services",
    path: "/services/sap-support-managed-services",
    desc: "Ensure uninterrupted business operations with proactive SAP support, monitoring, maintenance, and managed services.",
  },
  {
    icon: <SystemUpdateAltIcon />,
    title: "SAP Upgrade & Migration Services",
    path: "/services/sap-upgrade-migration-services",
    desc: "Modernize enterprise systems with secure SAP upgrades, migrations, and seamless transition strategies.",
  },
  {
    icon: <AutoAwesomeIcon />,
    title: "Digital Transformation",
    path: "/services/digital-transformation",
    desc: "Empower businesses with innovative digital technologies, automation, and intelligent transformation solutions.",
  },
  {
    icon: <CloudDoneIcon />,
    title: "Cloud Services",
    path: "/services/cloud-services",
    desc: "Build scalable, secure, and future-ready cloud infrastructure optimized for enterprise performance.",
  },
  {
    icon: <DeveloperModeIcon />,
    title: "Custom Application Development",
    path: "/services/custom-application-development",
    desc: "Develop scalable and user-friendly enterprise applications tailored to your operational requirements.",
  },
  {
    icon: <InsightsIcon />,
    title: "Data Analytics & Business Intelligence",
    path: "/services/data-analytics-business-intelligence",
    desc: "Transform business data into actionable insights with advanced analytics and business intelligence solutions.",
  },
  {
    icon: <PrecisionManufacturingIcon />,
    title: "AI, IoT & Intelligent Automation",
    path: "/services/ai-iot-intelligent-automation",
    desc: "Drive operational efficiency and innovation through AI-powered systems, IoT, and intelligent automation.",
  },
];

export default function ZenconCapabilities() {
  const navigate = useNavigate();
  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        overflow: "hidden",
        py: { xs: 8, md: 12 },
        background:
          "linear-gradient(135deg, #071525 0%, #082d63 55%, #06111f 100%)",
        color: "#fff",

        "&::before": {
          content: '""',
          position: "absolute",
          width: 520,
          height: 520,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(0,200,83,0.25), transparent 65%)",
          top: -180,
          right: -140,
          animation: "floatGlow 7s ease-in-out infinite",
        },

        "&::after": {
          content: '""',
          position: "absolute",
          width: 420,
          height: 420,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(62,23,255,0.35), transparent 65%)",
          bottom: -160,
          left: -120,
          animation: "floatGlow 8s ease-in-out infinite reverse",
        },

        "@keyframes floatGlow": {
          "0%, 100%": { transform: "translate(0, 0) scale(1)" },
          "50%": { transform: "translate(25px, -25px) scale(1.08)" },
        },

        "@keyframes orbit": {
          from: { transform: "rotate(0deg)" },
          to: { transform: "rotate(360deg)" },
        },

        "@keyframes moveLine": {
          "0%": { transform: "translateX(-100%)", opacity: 0 },
          "50%": { opacity: 1 },
          "100%": { transform: "translateX(100%)", opacity: 0 },
        },

        "@keyframes floatIcon": {
          "0%, 100%": { transform: "translateY(0)" },
          "50%": { transform: "translateY(-12px)" },
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
        <Box sx={{ mb: { xs: 3, md: 5 } }}>
          <Box
            sx={{
              width: 120,
              height: 5,
              borderRadius: 10,
              mb: 3,
              background: "linear-gradient(90deg, #00c853, #3e17ff)",
            }}
          />

          <Typography
            variant="h2"
            sx={{
              fontWeight: 800,
              fontSize: { xs: "2rem", sm: "2.4rem", md: "3rem" },
              lineHeight: 1.1,
            }}
          >
            Zencon{" "}
            <Box
              component="span"
              sx={{
                background: "linear-gradient(90deg, #00c853, #5b35ff)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Capabilities
            </Box>
          </Typography>

          <Typography
            sx={{
              mt: 2,
              maxWidth: 720,
              color: "rgba(255,255,255,0.72)",
              fontSize: { xs: "0.8rem", md: "1rem" },
              textAlign: "justify",
            }}
          >
            Modern SAP services built around development, integration, data,{" "}
            <br />
            cloud, security, and process optimization.
          </Typography>
        </Box>

        <Grid container spacing={2} spacing={5} alignItems="center">
          <Grid size={{ xs: 12, md: 6 }}>
            {/* <motion.div
              variants={slideLeft}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
            > */}
            <Grid container spacing={2}>
              {capabilities.map((item, index) => (
                <Grid item size={{ xs: 12, md: 6 }} key={item.title}>
                  <Card
                    sx={{
                      height: "100%",
                      p: 3,
                      borderRadius: 5,
                      background: "rgba(255,255,255,0.07)",
                      border: "1px solid rgba(255,255,255,0.12)",
                      boxShadow: "none",
                      backdropFilter: "blur(18px)",
                      transition: "0.35s ease",
                      animation: `floatIcon ${5 + index * 0.4}s ease-in-out infinite`,

                      "&:hover": {
                        transform: "translateY(-8px)",
                        background: "rgba(255,255,255,0.11)",
                        borderColor: "rgba(0,200,83,0.55)",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        mb: 2,
                      }}
                    >
                      <Box
                        sx={{
                          width: 50,
                          height: 50,
                          borderRadius: "15px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#00c853",
                          background: "rgba(0,200,83,0.12)",
                          flexShrink: 0,

                          "& svg": {
                            fontSize: 25,
                          },
                        }}
                      >
                        {item.icon}
                      </Box>

                      <Typography
                        sx={{
                          fontSize: "1rem",
                          fontWeight: 750,
                          color: "#fff",
                          lineHeight: 1.3,
                        }}
                      >
                        {item.title}
                      </Typography>
                    </Box>

                    <Typography
                      sx={{
                        color: "rgba(255,255,255,0.68)",
                        lineHeight: 1.2,
                        fontSize: "0.8rem",
                        textAlign: "justify",
                      }}
                    >
                      {item.desc}
                    </Typography>

                    <Button
                      onClick={() => navigate(item.path)}
                      sx={{
                        mt: 2.5,
                        px: 2.6,
                        py: 0.9,
                        borderRadius: 10,
                        textTransform: "none",
                        fontWeight: 700,
                        color: "#071525",
                        background: "#00c853",

                        "&:hover": {
                          background: "#19e06c",
                        },
                      }}
                    >
                      Read More
                    </Button>
                  </Card>
                </Grid>
              ))}
            </Grid>
            {/* </motion.div> */}
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <motion.div
              variants={slideRight}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
            >
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  minHeight: { xs: 360, sm: 420, md: 520 },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: { xs: 4, md: 0 },
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    width: { xs: 280, sm: 340, md: 410 },
                    height: { xs: 280, sm: 340, md: 410 },
                    borderRadius: "50%",
                    border: "1px solid rgba(255,255,255,0.14)",
                    animation: "orbit 24s linear infinite",
                  }}
                />

                <Box
                  sx={{
                    position: "absolute",
                    width: { xs: 220, sm: 280, md: 340 },
                    height: { xs: 220, sm: 280, md: 340 },
                    borderRadius: "50%",
                    border: "1px dashed rgba(0,200,83,0.42)",
                    animation: "orbit 16s linear infinite reverse",
                  }}
                />

                <Box
                  sx={{
                    width: { xs: 230, sm: 290, md: 340 },
                    height: { xs: 230, sm: 290, md: 340 },
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg, rgba(0,200,83,0.25), rgba(62,23,255,0.36))",
                    border: "1px solid rgba(255,255,255,0.16)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 30px 90px rgba(0,0,0,0.35)",
                    backdropFilter: "blur(20px)",
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  {/* Image */}
                  <Box
                    component="img"
                    src={capabilitiesImage}
                    alt="Zencon Tech"
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "center",
                      borderRadius: "50%",
                      transform: "scale(1.08)",
                      filter: "drop-shadow(0 0 30px rgba(0,255,200,0.18))",
                      animation: "float 6s ease-in-out infinite",
                      position: "relative",
                      zIndex: 2,
                    }}
                  />

                  {/* Glow Overlay */}
                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      borderRadius: "50%",
                      background:
                        "radial-gradient(circle at center, rgba(0,255,200,0.10), transparent 70%)",
                      zIndex: 3,
                      pointerEvents: "none",
                    }}
                  />

                  {/* Floating Animation */}
                  <style>
                    {`
      @keyframes float {
        0% {
          transform: scale(1.08) translateY(0px);
        }
        50% {
          transform: scale(1.08) translateY(-8px);
        }
        100% {
          transform: scale(1.08) translateY(0px);
        }
      }
    `}
                  </style>
                </Box>
                {["SAP", "API", "DATA", "CLOUD", "UX", "AI"].map((text, i) => (
                  <Box
                    key={text}
                    sx={{
                      position: "absolute",
                      px: 2,
                      py: 1,
                      borderRadius: 10,
                      fontWeight: 800,
                      fontSize: { xs: "0.75rem", md: "0.85rem" },
                      color: "#fff",
                      background: "rgba(255,255,255,0.12)",
                      border: "1px solid rgba(255,255,255,0.18)",
                      backdropFilter: "blur(10px)",
                      top: ["8%", "22%", "48%", "74%", "62%", "35%"][i],
                      left: ["25%", "68%", "78%", "58%", "16%", "10%"][i],
                      animation: `floatIcon ${4 + i * 0.5}s ease-in-out infinite`,
                    }}
                  >
                    {text}
                  </Box>
                ))}
              </Box>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
